import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.scss";

import Header from "components/Layout/Header";
import Button from "components/Button";
import { EKYC_SET_CORP_AUTH_TYPE } from "module/ekycModule";

const OPTIONS = [
    { value: "representative", label: "법인대표자 본인인증(개인신분증 OCR + 안면인증)" },
    { value: "delegate", label: "법인 업무 대리인 본인인증(개인 신분증 OCR + 안면인증)" },
];

const CorpAuthSelect = ({ open, onClose, history }) => {
    const dispatch = useDispatch();
    const [corpAuthType, setCorpAuthType] = useState("representative");

    const handleConfirm = () => {
        dispatch({ type: EKYC_SET_CORP_AUTH_TYPE, payload: corpAuthType });
        if (corpAuthType === "delegate") {
            history.push("/ekyc/corp/delegation");
        } else {
            history.push("/ekyc/start");
        }
    };

    if (!open) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.mobileHeader}>
                    <Header onClick={onClose} />
                </div>
                <button className={styles.closeBtn} onClick={onClose}>✕</button>
                <div className={styles.body}>
                    <h1 className={styles.title}>법인고객 비대면 본인인증</h1>
                    <p className={styles.desc}>본인 인증 절차를 선택해주세요.</p>
                    <div className={styles.checkboxGroup}>
                        {OPTIONS.map((option) => (
                            <label
                                key={option.value}
                                className={`${styles.checkboxItem} ${corpAuthType === option.value ? styles.checked : ""}`}
                            >
                                <input
                                    type="radio"
                                    name="corpAuthType"
                                    value={option.value}
                                    checked={corpAuthType === option.value}
                                    onChange={() => setCorpAuthType(option.value)}
                                />
                                <span className={styles.checkboxBox} />
                                <span className={styles.checkboxLabel}>{option.label}</span>
                            </label>
                        ))}
                    </div>
                    <div className={styles.btnGroup}>
                        <Button
                            text={"인증 진행"}
                            style={{ backgroundColor: "#DA291C" }}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CorpAuthSelect;
